'use client';

import { HorizontalOverflowCarousel } from '@petsmart-ui/sparky';
import { clsx } from '@libs/common-next';
import { productCarouselConfig } from '../../utils/productCarouselConfig';
import type { CarouselProps } from './types';
import { useWhiteSpaceCalculation } from '../../hooks';

export function Carousel({ children, productHits, variant, isInDrawer }: CarouselProps) {
    const whiteSpaceCalculate = useWhiteSpaceCalculation();
    const { disableArrows, ...carouselConfig } = productCarouselConfig(isInDrawer, variant, productHits.length);

    const carouselOptions = {
        className: clsx('product-carousel__carousel', disableArrows && 'product-carousel__carousel--disable-arrows'),
        ...carouselConfig,
    };

    const modifier = (translate: number) => {
        const { gap, perView } = carouselOptions.breakpoints['560'];

        if (whiteSpaceCalculate) {
            const qytTiles = productHits.length;

            return whiteSpaceCalculate(translate, perView, gap, qytTiles, isInDrawer);
        }

        return translate;
    };

    return (
        <HorizontalOverflowCarousel {...carouselOptions} modifier={modifier}>
            {children}
        </HorizontalOverflowCarousel>
    );
}
